export enum ELocalStorageMobile {
	SHOWN_CONTENT_INFO = 'shownContentInfo',
}
